<template>
  <div style="height:100%">
    <el-card class="box-card mb-2" :body-style="{ padding: '2px' }" shadow="always">
      <div ref="hb_table_query_container">
        <b-row>
          <b-col sm="auto" style="padding-top: 6px; padding-right: 2px">
            <i class="iconfont icon-search"></i><span style="margin: 4px">查询条件</span>
          </b-col>
          <b-col sm="auto" class="pl-1">
            {{ $t("common.customer") + $t("common.name") }}：<el-input clearable size="small"
              style="width: 200px"></el-input>
            物料名称：<el-input clearable size="small" style="width: 200px"></el-input>
          </b-col>
          <b-col sm="auto" style="padding-left: 2px; padding-right: 2px">
            物料家族：
            <el-cascader v-model="typeChoose" size="small" :options="familyOptions" :props="props" collapse-tags
              clearable style="width: 300px">
            </el-cascader>
          </b-col>
          <b-col sm="auto" style="padding-left: 2px; padding-right: 2px">
            <el-select v-model="dateChoose" placeholder="" size="small" style="width: 150px">
              <el-option v-for="item in dateOptions" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </b-col>
          <b-col class="pl-1">
            <el-button type="primary" class="iconfont icon-search" size="small" @click="onSearch">查询</el-button>
          </b-col>
        </b-row>
      </div>
    </el-card>
    <div ref="hb_table_toolbar_container">
      <div class="mt-1 mb-2 ml-2">
        <b-row align-v="center">
          <!-- 表名 -->
          <b-col sm="auto">
            <slot name="header">
              <i class="iconfont icon-table" style="font-size: 16px"><span class="ml-1"
                  style="font-size: 12px"><strong>净需求分析</strong></span></i>
            </slot>
          </b-col>
        </b-row>
      </div>
    </div>
    <b-table-simple small striped hover caption-top responsive bordered style="height:100%">
      <b-thead>
        <b-tr style="text-align: center; vertical-align: middle">
          <b-th colspan="1" :rowspan="searchTypeRow" style="vertical-align: middle">编号</b-th>
          <b-th colspan="1" :rowspan="searchTypeRow" style="vertical-align: middle">客户名称</b-th>
          <b-th colspan="1" :rowspan="searchTypeRow" style="vertical-align: middle">销售公司</b-th>
          <b-th colspan="1" :rowspan="searchTypeRow" style="vertical-align: middle">物料名称</b-th>
          <b-th colspan="1" :rowspan="searchTypeRow" style="vertical-align: middle">一级分类</b-th>
          <b-th colspan="1" :rowspan="searchTypeRow" style="vertical-align: middle">二级分类</b-th>
          <b-th colspan="1" :rowspan="searchTypeRow" style="vertical-align: middle">三级分类</b-th>
          <b-th colspan="1" :rowspan="searchTypeRow" style="vertical-align: middle">初始数据</b-th>
          <b-th :colspan="searchType" v-for="d in weekdata.col" :key="d">{{ d.name }}</b-th>
        </b-tr>
        <b-tr v-if="changeState == 2" style="text-align: center; vertical-align: middle">
          <b-th :colspan="searchType">{{ weekdata.month }}</b-th>
          <b-th :colspan="searchType">{{ weekdata.month }}</b-th>
          <b-th :colspan="searchType">{{ weekdata.month }}</b-th>
        </b-tr>
        <b-tr v-if="changeState == 3" style="text-align: center; vertical-align: middle">
          <b-th :colspan="3">Q1</b-th>
          <b-th :colspan="3">Q2</b-th>
          <b-th :colspan="3">Q3</b-th>
          <b-th :colspan="3">Q4</b-th>
          <b-th :colspan="3">Q1</b-th>
          <b-th :colspan="3">Q2</b-th>
          <b-th :colspan="3">Q3</b-th>
          <b-th :colspan="3">Q4</b-th>
          <b-th :colspan="3">Q1</b-th>
          <b-th :colspan="3">Q2</b-th>
          <b-th :colspan="3">Q3</b-th>
          <b-th :colspan="3">Q4</b-th>
        </b-tr>
        <b-tr>
          <b-th v-for="d in weekdata.days" :key="d">{{ d }}</b-th>
        </b-tr>
      </b-thead>
      <b-tbody>
        <b-tr v-for="item in weekdata.datas" :key="item" @click="selectRow(item)">
          <b-td colspan="8" v-if="item.isTotal && item.level == level" style="text-align: right">{{ item.totalname +
            "合计: " }}</b-td>
          <b-td colspan="7" v-if="item.isTotal && item.type == 1 && item.level == level">{{ item.w1 }}</b-td>
          <b-td colspan="7" v-if="item.isTotal && item.type == 1 && item.level == level">{{ item.w2 }}</b-td>
          <b-td colspan="7" v-if="item.isTotal && item.type == 1 && item.level == level">{{ item.w3 }}</b-td>
          <b-td colspan="7" v-if="item.isTotal && item.type == 1 && item.level == level">{{ item.w4 }}</b-td>
          <b-td colspan="4" v-if="item.isTotal && item.type == 2">{{ item.m1 }}</b-td>
          <b-td colspan="4" v-if="item.isTotal && item.type == 2">{{ item.m2 }}</b-td>
          <b-td colspan="4" v-if="item.isTotal && item.type == 2">{{ item.m3 }}</b-td>
          <b-td colspan="12" v-if="item.isTotal && item.type == 3">{{ item.q1 }}</b-td>
          <b-td colspan="12" v-if="item.isTotal && item.type == 3">{{ item.q2 }}</b-td>
          <b-td colspan="12" v-if="item.isTotal && item.type == 3">{{ item.q3 }}</b-td>
          <b-td v-if="item.id">{{ item.id }}</b-td>
          <b-td v-if="item.id">{{ item.custName }}</b-td>
          <b-td v-if="item.id">{{ item.company }}</b-td>
          <b-td v-if="item.id">{{ item.itemName }}</b-td>
          <b-td v-if="item.id">{{ item.itemType1 }}</b-td>
          <b-td v-if="item.id">{{ item.itemType2 }}</b-td>
          <b-td v-if="item.id">{{ item.itemType3 }}</b-td>
          <b-td v-if="item.id">{{ item.qty }}</b-td>
          <b-td v-if="item.id" v-for="data in item.monthdata" :key="data" :variant="data.color">{{
            data.data
            }}</b-td>
        </b-tr>
      </b-tbody>
    </b-table-simple>
    <b-row align-v="start" class="ml-1 mb-1">
      <b-col sm="auto">
        <el-button type="primary" size="mini" @click="totallevel(1)">一级汇总</el-button>
      </b-col>
      <b-col sm="auto">
        <el-button type="warning" size="mini" @click="totallevel(2)">二级汇总</el-button>
      </b-col>
      <b-col sm="auto">
        <el-button type="success" size="mini" @click="totallevel(3)">三级汇总</el-button>
      </b-col>
    </b-row>
    <b-row align-v="start">
      <b-col sm="auto">
        <el-pagination v-if="page_sizes !== null" :pager-count="pager_count" @size-change="handleSizeChange"
          @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="page_sizes"
          :page-size="page_sizes[0]" :layout="pager_layout" :total="items_count">
        </el-pagination>
      </b-col>
    </b-row>
    <el-drawer :title="title" :visible.sync="drawer" :direction="direction" size="50%">
      <div slot="title">
        <span>客户:</span>
        <el-tag type="danger" effect="dark" class="ml-2">{{ title.custName }}</el-tag><span class="ml-2">物料:</span>
        <el-tag type="danger" effect="dark" class="ml-2">{{ title.itemName }}</el-tag>
      </div>
      <div class="el-tabs-container">
        <el-tabs v-model="tab_index1">
          <el-tab-pane :label="$t('tab.tab_compute_process')">
            <el-table :data="tableData" style="width: 100%" :border="true">
              <el-table-column prop="month" label="month"> </el-table-column>
              <el-table-column prop="week" label="week"> </el-table-column>
              <el-table-column prop="forecast" label="Forecast"> </el-table-column>
              <el-table-column prop="custOrders" label="Customer Orders">
              </el-table-column>
              <el-table-column prop="order_purchase" label="Order in Purchase">
              </el-table-column>
              <el-table-column prop="order_production" label="Order in Production">
              </el-table-column>
              <el-table-column prop="order_trans" label="Order in Transportation">
              </el-table-column>
              <el-table-column prop="net_demand" label="Net Demand">
                <template slot-scope="scope">
                  <el-tag size="medium" :type="scope.row.net_demand > 0 ? 'parimary' : 'danger'" effect="dark">{{
                    scope.row.net_demand }}
                  </el-tag>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane :label="$t('tab.tab_compare_detail')">
            <b-table-simple small striped hover caption-top responsive bordered>
              <b-thead>
                <b-tr style="text-align: center; vertical-align: middle">
                  <b-th colspan="1" rowspan="2" style="vertical-align: middle">Version</b-th>
                  <b-th colspan="7" v-for="d in comparisondata.col" :key="d">{{ d.name }}</b-th>
                </b-tr>
                <b-tr>
                  <b-th v-for="d in comparisondata.days" :key="d">{{ d }}</b-th>
                </b-tr>
              </b-thead>
              <b-tbody>
                <b-tr v-for="item in comparisondata.datas" :key="item">
                  <b-td>{{ item.version }}</b-td>
                  <b-td v-for="data in item.monthdata" :variant="data.color" :key="data">{{
                    data.data
                    }}</b-td>
                </b-tr>
              </b-tbody>
            </b-table-simple>
            <b-row>
              <b-col sm="auto">
                <div class="mb-2">
                  <el-tag color="#B8DAFF" effect="dark" style="color: black; width: 60px">Forecast</el-tag>
                </div>
                <div>
                  <el-tag color="#C3E6B5" effect="dark" style="color: black; width: 60px">Actual</el-tag>
                </div>
              </b-col>
            </b-row>
          </el-tab-pane>
        </el-tabs>
      </div>
    </el-drawer>
  </div>
</template>

<script>
// -- import * as _ from "lodash-es"
import QueryButton from "../components/base/QueryButton"
export default {
  name: "NetDemandPlan",
  components: { QueryButton },
  data() {
    return {
      total: {
        type: 1,
        total: 0,
        totalw1: 0,
        totalw2: 0,
        totalw3: 0,
        totalw4: 0,
        totalm1: 0,
        totalm2: 0,
        totalm3: 0,
        totalq1: 0,
        totalq2: 0,
        totalq3: 0,
      },
      level: 4,
      title: {},
      tableData: [],
      drawer: false,
      direction: "rtl",
      props: { multiple: true },
      tab_index: 0,
      tab_index1: 0,
      weekdata: {
        col: [{ name: "W1" }, { name: "W2" }, { name: "W3" }, { name: "W4" }],
        datas: [],
      },
      comparisondata: {
        col: [{ name: "W1" }, { name: "W2" }, { name: "W3" }, { name: "W4" }],
        datas: [],
      },
      dateOptions: [],
      dateChoose: 1,
      typeOptions: [],
      familyOptions: [],
      typeChoose: [],
      searchType: 7,
      searchTypeRow: 2,
      changeState: 1,
      page_sizes: [50, 100, 200],
      pager_count: 7,
      currentPage: 1,
      perPage: 0,
      pager_layout: "total, sizes, prev, pager, next, jumper",
    }
  },
  computed: {
    items_count() {
      return this.weekdata.datas.length
    },
  },
  created() {
    //this.makeData();
    this.dateOptions.push({ label: "按周查询", value: 1 })
    this.dateOptions.push({ label: "按月查询", value: 2 })
    this.dateOptions.push({ label: "按季度查询", value: 3 })
    this.typeOptions.push({ label: "attribute1", value: "attribute1" })
    this.typeOptions.push({ label: "attribute2", value: "attribute2" })
    this.typeOptions.push({ label: "attribute3", value: "attribute3" })

    this.familyOptions.push(
      {
        label: "Type A",
        value: "Type A",
        children: [
          {
            label: "type A-1",
            value: "type A-1",
            children: [
              { label: "type A-1-1", value: "type A-1-1" },
              { label: "type A-1-2", value: "type A-1-2" },
              { label: "type A-1-3", value: "type A-1-3" },
            ],
          },
          {
            label: "type A-2",
            value: "type A-2",
            children: [
              { label: "type A-2-1", value: "type A-2-1" },
              { label: "type A-2-2", value: "type A-2-2" },
              { label: "type A-2-3", value: "type A-2-3" },
            ],
          },
          {
            label: "type A-3",
            value: "type A-3",
            children: [
              { label: "type A-3-1", value: "type A-3-1" },
              { label: "type A-3-2", value: "type A-3-2" },
              { label: "type A-3-3", value: "type A-3-3" },
            ],
          },
        ],
      },
      {
        label: "Type B",
        value: "Type B",
        children: [
          {
            label: "type B-1",
            value: "type B-1",
            children: [
              { label: "type B-1-1", value: "type B-1-1" },
              { label: "type B-1-2", value: "type B-1-2" },
              { label: "type B-1-3", value: "type B-1-3" },
            ],
          },
          {
            label: "type B-2",
            value: "type B-2",
            children: [
              { label: "type B-2-1", value: "type B-2-1" },
              { label: "type B-2-2", value: "type B-2-2" },
              { label: "type B-2-3", value: "type B-2-3" },
            ],
          },
          {
            label: "type B-3",
            value: "type B-3",
            children: [
              { label: "type B-3-1", value: "type B-3-1" },
              { label: "type B-3-2", value: "type B-3-2" },
              { label: "type B-3-3", value: "type B-3-3" },
            ],
          },
        ],
      },
      {
        label: "Type C",
        value: "Type C",
        children: [
          {
            label: "type C-1",
            value: "type C-1",
            children: [
              { label: "type C-1-1", value: "type C-1-1" },
              { label: "type C-1-2", value: "type C-1-2" },
              { label: "type C-1-3", value: "type C-1-3" },
            ],
          },
          {
            label: "type C-2",
            value: "type C-2",
            children: [
              { label: "type C-2-1", value: "type C-2-1" },
              { label: "type C-2-2", value: "type C-2-2" },
              { label: "type C-2-3", value: "type C-2-3" },
            ],
          },
          {
            label: "type C-3",
            value: "type C-3",
            children: [
              { label: "type C-3-1", value: "type C-3-1" },
              { label: "type C-3-2", value: "type C-3-2" },
              { label: "type C-3-3", value: "type C-3-3" },
            ],
          },
        ],
      }
    )
  },
  watch: {},
  methods: {
    totallevel(level) {
      this.level = level
    },
    selectRow(val) {
      console.log(val)
      this.comparisonData()
      this.drawer = true
      this.title.custName = val.custName
      this.title.itemName = val.itemName
      this.calcData()
    },
    calcData() {
      this.tableData = []
      this.tableData.push(
        {
          month: "Oct",
          week: 1,
          forecast: 20,
          custOrders: 19,
          order_purchase: 31,
          order_production: 14,
          order_trans: null,
          net_demand: 56,
        },
        {
          month: "Oct",
          week: 2,
          forecast: 22,
          custOrders: 170,
          order_purchase: null,
          order_production: 30,
          order_trans: 30,
          net_demand: -76,
        },
        {
          month: "Oct",
          week: 3,
          forecast: 21,
          custOrders: 15,
          order_purchase: 30,
          order_production: 90,
          order_trans: null,
          net_demand: 3,
        },
        {
          month: "Oct",
          week: 4,
          forecast: 25,
          custOrders: 11,
          order_purchase: 90,
          order_production: null,
          order_trans: null,
          net_demand: -3,
        },
        {
          month: "Nov",
          week: 1,
          forecast: 24,
          custOrders: 9,
          order_purchase: null,
          order_production: null,
          order_trans: null,
          net_demand: -36,
        },
        {
          month: "Nov",
          week: 2,
          forecast: 23,
          custOrders: 5,
          order_purchase: 20,
          order_production: 30,
          order_trans: null,
          net_demand: -14,
        },
        {
          month: "Nov",
          week: 3,
          forecast: 21,
          custOrders: 2,
          order_purchase: 50,
          order_production: null,
          order_trans: null,
          net_demand: 13,
        },
        {
          month: "Nov",
          week: 4,
          forecast: 21,
          custOrders: 1,
          order_purchase: null,
          order_production: 60,
          order_trans: null,
          net_demand: 51,
        }
      )
    },
    handleSizeChange(val) {
      // console.log(`每页 ${val} 条`);
      this.perPage = val
    },
    handleCurrentChange(val) {
      // console.log(`当前页: ${val}`);
      this.currentPage = val
    },

    onSearch() {
      let self = this
      if (this.dateChoose == 1) {
        this.searchType = 7
        this.searchTypeRow = 2
        this.changeState = 1
      } else if (this.dateChoose == 2) {
        this.searchType = 4
        this.searchTypeRow = 3
        this.changeState = 2
      } else {
        this.searchType = 12
        this.searchTypeRow = 3
        this.changeState = 3
      }
      this.makeData()
      console.log(this.typeChoose)
      //过滤类型
      let _data = []
      _.each(self.typeChoose, (t) => {
        _data = _data.concat(
          _.filter(self.weekdata.datas, function (o) {
            return o.itemType3 == t[2]
          })
        )
      })
      if (self.typeChoose.length > 0) {
        self.weekdata.datas = _data
      }
    },
    makeTypeData(index, type) {
      if (index < 2 || (index >= 6 && index < 8) || (index >= 12 && index < 14)) {
        return type + "-" + 1
      }
      if (
        (index >= 2 && index < 4) ||
        (index >= 8 && index < 10) ||
        (index >= 14 && index < 16)
      ) {
        return type + "-" + 2
      }
      if (
        (index >= 4 && index < 6) ||
        (index >= 10 && index < 12) ||
        (index >= 16 && index < 18)
      ) {
        return type + "-" + 3
      }
    },
    makeTypeDataB(index, type) {
      if (index % 2 != 0) {
        return type + "-" + 2
      } else {
        return type + "-" + 1
      }
    },
    makeData() {
      this.weekdata.days = []
      this.weekdata.datas = []
      this.weekdata.col = []
      this.weekdata.month = new Date().toDateString().split(" ")[1]
      if (this.dateChoose == 1) {
        this.weekdata.col.push({ name: "W1" })
        this.weekdata.col.push({ name: "W2" })
        this.weekdata.col.push({ name: "W3" })
        this.weekdata.col.push({ name: "W4" })
        for (var i = 0; i < 28; i++) {
          let date = new Date()
          this.weekdata.days.push(this.$date.format(this.$date.addDays(date, i), "M.d"))
        }
        for (var j = 0; j < 18; j++) {
          if (j == 2) {
            this.weekdata.datas.push({
              isTotal: true,
              type: 1,
              totalname: "Type A-1",
              w1: 46000,
              w2: 61000,
              w3: 90000,
              w4: 182000,
              level: 2,
            })
          }
          if (j == 4) {
            this.weekdata.datas.push({
              isTotal: true,
              type: 1,
              totalname: "Type A-2",
              w1: 46000,
              w2: 61000,
              w3: 90000,
              w4: 182000,
              level: 2,
            })
          }
          if (j == 6) {
            this.weekdata.datas.push({
              isTotal: true,
              type: 1,
              totalname: "Type A-3",
              w1: 46000,
              w2: 61000,
              w3: 90000,
              w4: 182000,
              level: 2,
            })
          }
          if (j == 6) {
            this.weekdata.datas.push({
              isTotal: true,
              type: 1,
              totalname: "Type A",
              w1: 138000,
              w2: 183000,
              w3: 270000,
              w4: 546000,
              level: 1,
            })
          }
          if (j == 8) {
            this.weekdata.datas.push({
              isTotal: true,
              type: 1,
              totalname: "Type B-1",
              w1: 46000,
              w2: 61000,
              w3: 90000,
              w4: 182000,
              level: 2,
            })
          }
          if (j == 10) {
            this.weekdata.datas.push({
              isTotal: true,
              type: 1,
              totalname: "Type B-2",
              w1: 46000,
              w2: 61000,
              w3: 90000,
              w4: 182000,
              level: 2,
            })
          }
          if (j == 12) {
            this.weekdata.datas.push({
              isTotal: true,
              type: 1,
              totalname: "Type B-3",
              w1: 46000,
              w2: 61000,
              w3: 90000,
              w4: 182000,
              level: 2,
            })
          }
          if (j == 12) {
            this.weekdata.datas.push({
              isTotal: true,
              type: 1,
              totalname: "Type B",
              w1: 138000,
              w2: 183000,
              w3: 270000,
              w4: 546000,
              level: 1,
            })
          }
          if (j == 14) {
            this.weekdata.datas.push({
              isTotal: true,
              type: 1,
              totalname: "Type C-1",
              w1: 46000,
              w2: 61000,
              w3: 90000,
              w4: 182000,
              level: 2,
            })
          }
          if (j == 16) {
            this.weekdata.datas.push({
              isTotal: true,
              type: 1,
              totalname: "Type C-2",
              w1: 46000,
              w2: 61000,
              w3: 90000,
              w4: 182000,
              level: 2,
            })
          }
          this.weekdata.datas.push({
            id: j + 1,
            custName: "user" + (j + 1),
            company: "070",
            itemName: "item" + (j + 1),
            itemType1: j < 6 ? "Type A" : j > 11 ? "Type C" : "Type B",
            itemType2: this.makeTypeData(
              j,
              j < 6 ? "Type A" : j > 11 ? "Type C" : "Type B"
            ),
            itemType3: this.makeTypeDataB(
              j,
              this.makeTypeData(j, j < 6 ? "Type A" : j > 11 ? "Type C" : "Type B")
            ),
            qty: 200,
            monthdata: [
              { data: 2000, color: "success" },
              { data: 3000, color: "success" },
              { data: 4000, color: "success" },
              { data: 3000, color: "success" },
              { data: 5000, color: "success" },
              { data: 6000, color: "success" },
              { data: 7000, color: "success" },
              { data: 2000, color: "warning" },
              { data: 4000, color: "warning" },
              { data: 5000, color: "warning" },
              { data: 7000, color: "warning" },
              { data: 5600, color: "warning" },
              { data: 4500, color: "warning" },
              { data: 2400, color: "warning" },
              { data: 3000, color: "primary" },
              { data: 4000, color: "primary" },
              { data: 5000, color: "primary" },
              { data: 6000, color: "primary" },
              { data: 8000, color: "primary" },
              { data: 9000, color: "primary" },
              { data: 10000, color: "primary" },
              { data: 10000, color: "danger" },
              { data: 11000, color: "danger" },
              { data: 12000, color: "danger" },
              { data: 13000, color: "danger" },
              { data: 14000, color: "danger" },
              { data: 15000, color: "danger" },
              { data: 16000, color: "danger" },
            ],
          })
          this.weekdata.datas.push({
            isTotal: true,
            type: 1,
            totalname: this.makeTypeDataB(
              j,
              this.makeTypeData(j, j < 6 ? "Type A" : j > 11 ? "Type C" : "Type B")
            ),
            w1: 23000,
            w2: 30500,
            w3: 45000,
            w4: 91000,
            level: 3,
          })
        }
        this.weekdata.datas.push({
          isTotal: true,
          type: 1,
          totalname: "Type C",
          w1: 138000,
          w2: 183000,
          w3: 270000,
          w4: 546000,
          level: 1,
        })

        this.weekdata.datas.push({
          isTotal: true,
          type: 1,
          totalname: "Type C-3",
          w1: 46000,
          w2: 61000,
          w3: 90000,
          w4: 182000,
          level: 2,
        })
        this.levelTotal(1)
      } else if (this.dateChoose == 2) {
        this.weekdata.col.push({ name: "Forecast+Order(Demand)" })
        this.weekdata.col.push({
          name: "purchase+production+Transportation(Supply)",
        })
        this.weekdata.col.push({ name: "Net Demand" })
        for (var k = 0; k < 3; k++) {
          this.weekdata.days.push("W1")
          this.weekdata.days.push("W2")
          this.weekdata.days.push("W3")
          this.weekdata.days.push("W4")
        }

        for (var j = 0; j < 18; j++) {

          this.weekdata.datas.push({
            id: j + 1,
            custName: "user" + (j + 1),
            company: "070",
            itemName: "item" + (j + 1),
            itemType1: j < 6 ? "Type A" : j > 11 ? "Type C" : "Type B",
            itemType2: this.makeTypeData(
              j,
              j < 6 ? "Type A" : j > 11 ? "Type C" : "Type B"
            ),
            itemType3: this.makeTypeDataB(
              j,
              this.makeTypeData(j, j < 6 ? "Type A" : j > 11 ? "Type C" : "Type B")
            ),
            qty: 200,
            monthdata: [
              { data: 200, color: "success" },
              { data: 100, color: "success" },
              { data: 800, color: "success" },
              { data: 300, color: "success" },
              { data: 100, color: "warning" },
              { data: 300, color: "warning" },
              { data: 400, color: "warning" },
              { data: 0, color: "warning" },
              { data: 100, color: "danger" },
              { data: 300, color: "danger" },
              { data: -100, color: "danger" },
              { data: -400, color: "danger" },
            ],
          })
        }
      } else {
        this.weekdata.col.push({ name: "Forecast+Order(Demand)" })
        this.weekdata.col.push({
          name: "purchase+production+Transportation(Supply)",
        })
        this.weekdata.col.push({ name: "Net Demand" })
        for (var k = 0; k < 3; k++) {
          this.weekdata.days.push("Jan")
          this.weekdata.days.push("Feb")
          this.weekdata.days.push("Mar")
          this.weekdata.days.push("Apr")
          this.weekdata.days.push("May")
          this.weekdata.days.push("Jun")
          this.weekdata.days.push("Jul")
          this.weekdata.days.push("Aug")
          this.weekdata.days.push("Sep")
          this.weekdata.days.push("Oct")
          this.weekdata.days.push("Nov")
          this.weekdata.days.push("Dec")
        }

        for (var j = 0; j < 18; j++) {

          this.weekdata.datas.push({
            id: j + 1,
            custName: "user" + (j + 1),
            company: "070",
            itemName: "item" + (j + 1),
            itemType1: j < 6 ? "Type A" : j > 11 ? "Type C" : "Type B",
            itemType2: this.makeTypeData(
              j,
              j < 6 ? "Type A" : j > 11 ? "Type C" : "Type B"
            ),
            itemType3: this.makeTypeDataB(
              j,
              this.makeTypeData(j, j < 6 ? "Type A" : j > 11 ? "Type C" : "Type B")
            ),
            qty: 200,
            monthdata: [
              { data: 200, color: "success" },
              { data: 100, color: "success" },
              { data: 800, color: "success" },
              { data: 400, color: "success" },
              { data: 500, color: "success" },
              { data: 600, color: "success" },
              { data: 700, color: "success" },
              { data: 800, color: "success" },
              { data: 900, color: "success" },
              { data: 1000, color: "success" },
              { data: 1100, color: "success" },
              { data: 1200, color: "success" },
              { data: 300, color: "warning" },
              { data: 100, color: "warning" },
              { data: 300, color: "warning" },
              { data: 400, color: "warning" },
              { data: 500, color: "warning" },
              { data: 600, color: "warning" },
              { data: 700, color: "warning" },
              { data: 800, color: "warning" },
              { data: 900, color: "warning" },
              { data: 1000, color: "warning" },
              { data: 1100, color: "warning" },
              { data: 1200, color: "warning" },
              { data: 300, color: "danger" },
              { data: 100, color: "danger" },
              { data: 300, color: "danger" },
              { data: 400, color: "danger" },
              { data: 500, color: "danger" },
              { data: 600, color: "danger" },
              { data: 700, color: "danger" },
              { data: 800, color: "danger" },
              { data: 900, color: "danger" },
              { data: 1000, color: "danger" },
              { data: 1100, color: "danger" },
              { data: 1200, color: "danger" },
            ],
          })
        }

      }
    },
    comparisonData() {
      this.comparisondata.days = []
      this.comparisondata.datas = []
      this.comparisondata.col = []

      this.comparisondata.col.push({ name: "W1" })
      this.comparisondata.col.push({ name: "W2" })
      this.comparisondata.col.push({ name: "W3" })
      this.comparisondata.col.push({ name: "W4" })
      for (var i = 0; i < 28; i++) {
        let date = new Date()
        this.comparisondata.days.push(
          this.$date.format(this.$date.addDays(date, i), "M.d")
        )
      }

      this.comparisondata.datas.push(
        {
          version: "Forecast-V1",
          monthdata: [
            { data: 2000, color: "primary" },
            { data: 3000, color: "primary" },
            { data: 4000, color: "primary" },
            { data: 3000, color: "primary" },
            { data: 5000, color: "primary" },
            { data: 6000, color: "primary" },
            { data: 7000, color: "primary" },
            { data: 2000, color: "primary" },
            { data: 4000, color: "primary" },
            { data: 5000, color: "primary" },
            { data: 7000, color: "primary" },
            { data: 5600, color: "primary" },
            { data: 4500, color: "primary" },
            { data: 2400, color: "primary" },
            { data: 3000, color: "primary" },
            { data: 4000, color: "primary" },
            { data: 5000, color: "primary" },
            { data: 6000, color: "primary" },
            { data: 8000, color: "primary" },
            { data: 9000, color: "primary" },
            { data: 10000, color: "primary" },
            { data: 10000, color: "primary" },
            { data: 11000, color: "primary" },
            { data: 12000, color: "primary" },
            { data: 13000, color: "primary" },
            { data: 14000, color: "primary" },
            { data: 15000, color: "primary" },
            { data: 16000, color: "primary" },
          ],
        },
        {
          version: "Forecast-V2",
          monthdata: [
            { data: 0, color: "success" },
            { data: 2000, color: "success" },
            { data: 5000, color: "success" },
            { data: 2000, color: "success" },
            { data: 4000, color: "success" },
            { data: 3000, color: "success" },
            { data: 8000, color: "success" },
            { data: 3000, color: "primary" },
            { data: 3000, color: "primary" },
            { data: 6000, color: "primary" },
            { data: 9000, color: "primary" },
            { data: 3000, color: "primary" },
            { data: 6000, color: "primary" },
            { data: 4000, color: "primary" },
            { data: 3000, color: "primary" },
            { data: 4000, color: "primary" },
            { data: 5000, color: "primary" },
            { data: 6000, color: "primary" },
            { data: 8000, color: "primary" },
            { data: 9000, color: "primary" },
            { data: 10000, color: "primary" },
            { data: 10000, color: "primary" },
            { data: 11000, color: "primary" },
            { data: 12000, color: "primary" },
            { data: 13000, color: "primary" },
            { data: 14000, color: "primary" },
            { data: 15000, color: "primary" },
            { data: 16000, color: "primary" },
          ],
        },
        {
          version: "Order",
          monthdata: [
            { data: null, color: "primary" },
            { data: null, color: "primary" },
            { data: null, color: "primary" },
            { data: null, color: "primary" },
            { data: null, color: "primary" },
            { data: null, color: "primary" },
            { data: null, color: "primary" },
            { data: null, color: "primary" },
            { data: null, color: "primary" },
            { data: null, color: "primary" },
            { data: 8000, color: "success" },
            { data: null, color: "primary" },
            { data: null, color: "primary" },
            { data: null, color: "primary" },
            { data: 2000, color: "success" },
            { data: 3000, color: "success" },
            { data: 6000, color: "success" },
            { data: 7000, color: "success" },
            { data: 7500, color: "success" },
            { data: 3000, color: "success" },
            { data: 8000, color: "success" },
            { data: null, color: "primary" },
            { data: null, color: "primary" },
            { data: null, color: "primary" },
            { data: null, color: "primary" },
            { data: null, color: "primary" },
            { data: null, color: "primary" },
            { data: null, color: "primary" },
          ],
        },
        {
          version: "Forecast Balance V1",
          monthdata: [
            { data: null, color: "primary" },
            { data: null, color: "primary" },
            { data: null, color: "primary" },
            { data: null, color: "primary" },
            { data: null, color: "primary" },
            { data: null, color: "primary" },
            { data: null, color: "primary" },
            { data: 3000, color: "primary" },
            { data: 3000, color: "primary" },
            { data: 6000, color: "primary" },
            { data: 1000, color: "primary" },
            { data: 3600, color: "primary" },
            { data: 6500, color: "primary" },
            { data: 4400, color: "primary" },
            { data: 3000, color: "primary" },
            { data: 4000, color: "primary" },
            { data: 5000, color: "primary" },
            { data: 6000, color: "primary" },
            { data: 8000, color: "primary" },
            { data: 9000, color: "primary" },
            { data: 10000, color: "primary" },
            { data: 10000, color: "primary" },
            { data: 11000, color: "primary" },
            { data: 12000, color: "primary" },
            { data: 13000, color: "primary" },
            { data: 14000, color: "primary" },
            { data: 15000, color: "primary" },
            { data: 16000, color: "primary" },
          ],
        },
        {
          version: "Forecast Balance V2",
          monthdata: [
            { data: null, color: "primary" },
            { data: null, color: "primary" },
            { data: null, color: "primary" },
            { data: null, color: "primary" },
            { data: null, color: "primary" },
            { data: null, color: "primary" },
            { data: null, color: "primary" },
            { data: 0, color: "primary" },
            { data: 0, color: "primary" },
            { data: 0, color: "primary" },
            { data: 0, color: "primary" },
            { data: 0, color: "primary" },
            { data: 2000, color: "primary" },
            { data: 4000, color: "primary" },
            { data: 3000, color: "primary" },
            { data: 4000, color: "primary" },
            { data: 5000, color: "primary" },
            { data: 6000, color: "primary" },
            { data: 8000, color: "primary" },
            { data: 9000, color: "primary" },
            { data: 10000, color: "primary" },
            { data: 10000, color: "primary" },
            { data: 11000, color: "primary" },
            { data: 12000, color: "primary" },
            { data: 13000, color: "primary" },
            { data: 14000, color: "primary" },
            { data: 15000, color: "primary" },
            { data: 16000, color: "primary" },
          ],
        }
      )
    },
  },
}
</script>

<style>
.hb_table_forecast_class1 {
  width: 100%;
  font-size: 0.8rem;
  background-color: white;
  min-width: 150rem;
}

.hb_table_forecast_class2 {
  width: 100%;
  font-size: 0.8rem;
  background-color: white;
  min-width: 65rem;
}

.hb_table_forecast_class3 {
  width: 100%;
  font-size: 0.8rem;
  background-color: white;
  min-width: 115rem;
}
</style>

<style scoped>
.one_table>>>.hb_table_query_container_one_table {
  background-color: white;
}

.hb_table_panel_container_myName>>>.b-table-sticky-header>.table.b-table>.hb_thead>.hb_thead_tr>.b-table-sticky-column.hb_thead_th_name {
  left: 21px;
}

.hb_table_panel_container_myName>>>.b-table-sticky-header>.table.b-table>.hb_tbody>.hb_tbody_tr>.b-table-sticky-column.hb_tbody_td_name {
  left: 21px;
}
</style>
